import { FinancialDocumentExtended } from "@common/types/financialDocument";
import { IntegrationAccount } from "@common/types/integrationAccount";

export enum ImporterSort {
    FILE_NAME_ASC = "FILE_NAME_ASC",
    FILE_NAME_DESC = "FILE_NAME_DESC",
    STATUS_ASC = "STATUS_ASC",
    STATUS_DESC = "STATUS_DESC",
    BANK_ASC = "BANK_ASC",
    BANK_DESC = "BANK_DESC",
    ACCOUNT_TYPE_ASC = "ACCOUNT_TYPE_ASC",
    ACCOUNT_TYPE_DESC = "ACCOUNT_TYPE_DESC",
    PERIOD_START_ASC = "PERIOD_START_ASC",
    PERIOD_START_DESC = "PERIOD_START_DESC",
    PERIOD_END_ASC = "PERIOD_END_ASC",
    PERIOD_END_DESC = "PERIOD_END_DESC",
    TRANSACTIONS_ASC = "TRANSACTIONS_ASC",
    TRANSACTIONS_DESC = "TRANSACTIONS_DESC",
}

export interface ImporterDocumentRow {
    id: string;
    file?: File;
    financialDocument?: FinancialDocumentExtended;
    integrationAccount?: IntegrationAccount;
}
